import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxCalculatorresultskeyitem } from './Calculatorresultskeyitem'
import { CalculatorresultskeyitemProps } from './Calculatorresultskeyitem'

interface CalculatorresultskeyitemBlokProps {
  blok: {
    title: CalculatorresultskeyitemProps['title']
    highscore: CalculatorresultskeyitemProps['highscore']
    mediumscore: CalculatorresultskeyitemProps['mediumscore']
    lowscore: CalculatorresultskeyitemProps['lowscore']
  } & SbBlokData
}

const Calculatorresultskeyitem: FC<CalculatorresultskeyitemBlokProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxCalculatorresultskeyitem
        title={blok.title}
        highscore={blok.highscore}
        mediumscore={blok.mediumscore}
        lowscore={blok.lowscore}
      />
    </div>
  )
}

export default Calculatorresultskeyitem
